import React from 'react'
import styled, { keyframes } from 'styled-components'

const ellipsis = keyframes`
  to {
    width: 1.25em;
  }
`

const AnimatedEllipsis = styled.span`
  &::after {
    content: '\\2026';
    display: inline-block;
    width: 0px;
    overflow: hidden;
    vertical-align: bottom;
    animation: ${ellipsis} steps(4, end) 1.5s infinite;
  }
`

export default AnimatedEllipsis

const TextWithEllipsisContainer = styled.span`
  position: relative;
  padding-right: 0.5em;
`

const AbsoluteEllipsesContainer = styled.span`
  position: absolute;
`

// eslint-disable-next-line
export const TextWithEllipsis = ({ children, ...props }) => (
  <TextWithEllipsisContainer {...props}>
    {children}
    <AbsoluteEllipsesContainer>
      <AnimatedEllipsis />
    </AbsoluteEllipsesContainer>
  </TextWithEllipsisContainer>
)
